/**
 * ブラウザ起動エントリーポイント
 * React 19のcreateRootでアプリをDOMへ描画します。
 */

import React from "react";
import { createRoot } from "react-dom/client";
import App from "../App";
import { initTextSizePreference } from "./shared/services/textSizePreference";

/** 描画先要素 */
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("アプリケーションの描画先 #root が見つかりません。");
}

// 保存した文字の大きさを最初の描画より前に反映し、標準の大きさで一瞬描かれるのを防ぐ。
// 読み込みが想定外に失敗しても、画面を描かないままにはしない（finally）
void initTextSizePreference().finally(() => {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
